import { useRef } from "react";
import type { ReactElement } from "react";
import { Hinweis } from "@kundeninfo/ui/me-design";
import { KiKnopf } from "../../components/meHuellen.js";

/** Quittung einer Ablage mit „Rückgängig" als Gegenbuchung (F23) — seit me-design 467eb9b das
 *  ME-Element `me-hinweis schwebend schliessbar dauer` (Übergang T-4 abgelöst). Das Element
 *  schließt nach `dauer` selbst, hält die Uhr an, solange Zeiger oder Fokus darauf liegen, bringt
 *  das Kreuz mit und meldet alles als `me-geschlossen` ({grund: 'kreuz'|'dauer'|'escape'}); es trägt
 *  `role="status"` (die einzige Ansage einer Ablage). Seit me-design f87a0ef pausiert die Uhr bei
 *  Zeiger ODER Fokus und Escape (Fokus darin) schließt das Element selbst: `grund: 'escape'`. */
export const QUITTUNG_MS = 7_000;

export function TicketQuittung(p: { text: string; onRueckgaengig: () => void; onSchliessen: () => void }): ReactElement {
  const schliessen = useRef(p.onSchliessen);
  schliessen.current = p.onSchliessen;
  return (
    <Hinweis className="tq" aria-label="Quittung" schwebend schliessbar dauer={QUITTUNG_MS}
      onGeschlossen={() => schliessen.current()}
      aktionen={<KiKnopf art="leise" onClick={p.onRueckgaengig}>Rückgängig</KiKnopf>}>
      {p.text}
    </Hinweis>
  );
}
